import React, { useState, useEffect } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { translations } from '../data/siteTranslations';

export default function TestimonialSlider() {
  const { lang, getLoc } = useLanguage();
  const t = translations[lang].testimonials;
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function loadTestimonials() {
      try {
        const res = await fetch('https://api.dev.auxo.dk/public/content/testimonials');
        if (res.ok) {
          const data = await res.json();
          if (Array.isArray(data) && data.length > 0) {
            setItems(data);
            setLoading(false);
            return;
          }
        }
      } catch (err) {
        // Fallback
      }

      // Default fallback reviews
      setItems([
        {
          id: '1',
          author_name: 'Mette S.',
          role: { da: 'Fast klient gennem 4 år', en: 'Regular client for 4 years' },
          quote: {
            da: 'Jette har en helt særlig evne til at mærke præcis, hvor spændingerne sidder. Efter 29 års erfaring kan man mærke hendes dybe ro og overskud i hvert eneste greb.',
            en: 'Jette has an extraordinary ability to sense exactly where tension resides. With 29 years of experience, her calm presence is felt in every hold.'
          },
          rating: 5
        },
        {
          id: '2',
          author_name: 'Thomas B.',
          role: { da: 'Løber & kontorarbejdende', en: 'Runner & desk worker' },
          quote: {
            da: 'Hendes bindevævsmassage har gjort underværker for min ryg. Salig-klinikken på Masnedøgade er et fantastisk helle midt i København.',
            en: 'Her deep tissue massage worked wonders for my back. The Salig clinic on Masnedøgade is a serene haven in Copenhagen.'
          },
          rating: 5
        },
        {
          id: '3',
          author_name: 'Camilla & Baby',
          role: { da: 'Gravid- og efterfødselsklient', en: 'Pregnancy & post-partum client' },
          quote: {
            da: 'Både gravidmassagen og efterfødselsbehandlingen hos Jette var den bedste gave, jeg gav mig selv. Man føler sig tryg, set og utrolig godt behandlet.',
            en: 'Both the pregnancy and post-partum treatment with Jette were the best gifts I gave myself. You feel safe, listened to, and deeply nurtured.'
          },
          rating: 5
        },
        {
          id: '4',
          author_name: 'Lars K.',
          role: { da: 'Kranio-sakral klient', en: 'Craniosacral client' },
          quote: {
            da: 'Biodynamisk kranio-sakral terapi hos Jette bragte mit nervesystem til ro efter en lang periode med stress. Hendes nærvær og intuition er enestående.',
            en: 'Biodynamic craniosacral therapy with Jette brought my nervous system to rest after a stressful period. Her intuition and presence are unparalleled.'
          },
          rating: 5
        }
      ]);
      setLoading(false);
    }

    loadTestimonials();
  }, []);

  if (loading) {
    return (
      <div className="py-12 text-center text-[#6E6760]">
        <i className="fa-solid fa-spinner animate-spin text-2xl text-[#2E3191]" />
      </div>
    );
  }

  // Duplicate list to create a seamless infinite marquee slider effect
  const duplicated = [...items, ...items, ...items];

  return (
    <section className="py-20 bg-[#F4EFEA] border-y border-[#E8E0D7] overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-12 text-center">
        <span className="text-xs font-semibold uppercase tracking-widest text-[#2E3191] bg-[#EEF0F8] px-3 py-1 rounded-full border border-[#2E3191]/20 inline-block mb-3">
          {t.tag}
        </span>
        <h2 className="font-serif-display text-3xl sm:text-4xl font-bold text-[#2C2825]">
          {t.title}
        </h2>
        <p className="mt-3 text-base text-[#6E6760] max-w-2xl mx-auto">
          {t.subtitle}
        </p>
      </div>

      {/* Infinite Marquee Container */}
      <div className="relative w-full">
        <div className="animate-infinite-scroll flex gap-6 px-4">
          {duplicated.map((item, idx) => (
            <div
              key={`${item.id}-${idx}`}
              className="w-[300px] sm:w-[360px] md:w-[400px] shrink-0 bg-white p-6 sm:p-8 rounded-2xl border border-[#E8E0D7] shadow-xs flex flex-col justify-between"
            >
              <div>
                <div className="flex items-center gap-1 text-[#A86D51] mb-4 text-xs">
                  {[...Array(item.rating || 5)].map((_, i) => (
                    <i key={i} className="fa-solid fa-star" />
                  ))}
                </div>
                <p className="font-serif-display text-lg italic text-[#2C2825] leading-relaxed mb-6">
                  "{getLoc(item.quote)}"
                </p>
              </div>

              <div className="pt-4 border-t border-[#F3EFEA] flex items-center justify-between">
                <div>
                  <h4 className="text-sm font-bold text-[#2C2825]">
                    {item.author_name}
                  </h4>
                  <p className="text-xs text-[#6E6760]">
                    {getLoc(item.role)}
                  </p>
                </div>
                <i className="fa-solid fa-quote-right text-2xl text-[#2E3191]/20" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
